import {
  Users,
  GraduationCap,
  UserCheck,
  Briefcase,
  Coffee,
  AlertCircle,
  Sun,
  Globe,
} from "lucide-react";

const getEventTypes = (t, language) => [
  {
    id: "meeting",
    name: t.meetings,
    icon: Users,
    color: "#2e7cba",
    description: language === "ar" ? "اجتماعات الفريق والمؤتمرات" : "Team meetings and conferences",
    category: "work",
  },
  {
    id: "training",
    name: t.training,
    icon: GraduationCap,
    color: "#2e7cba",
    description: language === "ar" ? "جلسات التعلم والتطوير" : "Learning and development sessions",
    category: "development",
  },
  {
    id: "interview",
    name: t.interviews,
    icon: UserCheck,
    color: "#8b5cf6",
    description: language === "ar" ? "مقابلات وتقييمات المرشحين" : "Candidate interviews and assessments",
    category: "hr",
  },
  {
    id: "review",
    name: t.reviews,
    icon: Briefcase,
    color: "#f59e0b",
    description: language === "ar" ? "مراجعات وتقييمات الأداء" : "Performance reviews and evaluations",
    category: "hr",
  },
  {
    id: "social",
    name: t.social,
    icon: Coffee,
    color: "#ef4444",
    description: language === "ar" ? "بناء الفريق والأحداث الاجتماعية" : "Team building and social events",
    category: "social",
  },
  {
    id: "deadline",
    name: t.deadlines,
    icon: AlertCircle,
    color: "#dc2626",
    description: language === "ar" ? "المواعيد النهائية للمشروع والمعالم" : "Project deadlines and milestones",
    category: "work",
  },
  {
    id: "vacation",
    name: t.vacation,
    icon: Sun,
    color: "#06b6d4",
    description: language === "ar" ? "الوقت الشخصي والعطلات" : "Personal time off and holidays",
    category: "personal",
  },
  {
    id: "conference",
    name: t.conferences,
    icon: Globe,
    color: "#84cc16",
    description: language === "ar" ? "مؤتمرات وأحداث الصناعة" : "Industry conferences and events",
    category: "professional",
  },
];

export default getEventTypes;
